export const environment = {
    production: true,
    institutionCode: 'TCM',
    s3Images: 'https://creditsnap-public.s3.amazonaws.com/',
    debug: false,
    type: 'PROD',
    cxUrl:'https://apply.mycommunityccard.com/',
    apiUrl:'https://prod-api-elb2.creditsnap.com/csb2b/',
    auth: {
        basic: 'Basic Y3NfdHJ1c3RlZF9jbGllbnRfcHJvZDpqM3JYSkE2UEx5SkVNSm1N',
        scope: 'read write trust',
        grantType: 'password',
        interceptorSkipHeader: 'X-Skip-Interceptor'
    },
};
